import { MDBIcon } from "mdbreact";
import { Link } from "react-router-dom";
import handleCurrency from "../../../components/CurrencyFormat";
import handleProductCode from "../../../components/ProductCode";
import formatDateTimeWIB from "../../../helpers/formatDateTimeWib";

export default function DataInvoice({ row, index, active, onChecked }) {
  const showCheckbox = active === "waiting";
  const showAction = active !== "summary";

  return (
    <tr>
      {showCheckbox && (
        <td>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id={`tableCheckbox${index}`}
              onChange={(event) => onChecked(event, row)}
              checked={row.checked}
            />
            <label
              className="custom-control-label font-weight-bold"
              htmlFor={`tableCheckbox${index}`}
            />
          </div>
        </td>
      )}
      <td>
        <div>{row.invoiceNumber}</div>
        <div>{row.placingSlipNo || "-"}</div>
        <div>{row.policyNumber}</div>
        <div style={{ wordWrap: "break-word" }}>{row.refNumber || "-"}</div>
      </td>
      <td>{handleProductCode(row.productCode)}</td>
      <td>
        {row.companyName} <br />
        {row.insured} <br />
        {row.insurer}
      </td>
      <td>
        <div>
          {formatDateTimeWIB(row.policyIssueDate, "DD MMM YYYY HH:mm:ss [WIB]")}
        </div>
        <div>
          {formatDateTimeWIB(
            row.invoiceIssueDate,
            "DD MMM YYYY HH:mm:ss [WIB]",
          )}
        </div>
        <div>
          {formatDateTimeWIB(
            row.schedulePaymentDate,
            "DD MMM YYYY HH:mm:ss [WIB]",
          )}
        </div>
        <div>
          {formatDateTimeWIB(row.paymentDate, "DD MMM YYYY HH:mm:ss [WIB]")}
        </div>
      </td>
      <td>
        <div>{`${row.currencyCode} ${handleCurrency(row.sumInsured)}`}</div>
        <div>
          {`${row.currencyCodeForPremium} ${handleCurrency(row.premium)}`}
        </div>
      </td>
      {showAction && (
        <td>
          <div className="d-flex justify-content-center align-items-center">
            <Link
              to={`/invoice/${btoa(row.id)}`}
              className="action-button"
              onClick={() => window.scrollTo(0, 0)}
            >
              <MDBIcon icon="chevron-right" size="lg" className="white-text" />
            </Link>
          </div>
        </td>
      )}
    </tr>
  );
}
